
<header class="shadow rounded bg-light">
  <div class="row">
  <div class="col-3">
    <img priority  [ngSrc]="logo" class="img-fluid" alt="FL header logo picture"
    height="110" width="215"/>
  </div>
  <div class="col text-center">
    <br />
    <h1 class=" fw-bold"> Florida HIPP Program Online Application

    </h1>
    <strong>Fill out this form and click Submit to apply.</strong>
    <p>If you prefer to download an Florida HIPP program Application
      <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" (click)="openPaperApplication()">click here</a></p>
  </div>
  <div class="col-2"></div>
</div>
</header>
<br />
<main >

      <app-flform  [preference]="preference"
    [errorMessageIntialData]="errorMessageIntialData" [email]="email" [mailingAddress]="mailingAddress" [emailTo]="emailTo"
    [faxNo]="faxNo" [tollfreeNo]="tollfreeNo" [dropingAddress]="dropingAddress" [mailingOffice]="mailingOffice" [mailingAddressLine]="mailingAddressLine" [mailingCityStateZip]="mailingCityStateZip"></app-flform>


  </main>
  <br />
<footer class=" text-center bg-light">

  <p>
    Email <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #0c69f2;">{{email}}</a> |
    Fax {{faxNo}} | Phone {{tollfreeNo}} | Mail to {{mailingAddress}}
  </p>
  <div class="text-dark  p-3 bg-secondary bg-opacity-50 bg-gradient">HMS, Inc. All Rights Reserved</div>


</footer>

<fl-app-scroll-top></fl-app-scroll-top>
